export const SENTRY_DSN =
  "https://a29f6cb2bf564091ab20d21c459f83ef@o6997.ingest.sentry.io/5876311";

export const SENTRY_LOADER_SCRIPT_URL =
  "https://js.sentry-cdn.com/a29f6cb2bf564091ab20d21c459f83ef.min.js";

export const SENTRY_ENVIRONMENT = process.env.NEXT_PUBLIC_SENTRY_ENVIRONMENT;

export const IS_SENTRY_STAGING_ENV = SENTRY_ENVIRONMENT === "staging";

export const IS_SENTRY_PROD_ENV = SENTRY_ENVIRONMENT === "prod";
